<script>
import baseList from "@/views/components/base/baseList.vue";
import config from "../../../config";
import Caigouhetong from "./Procurementcomponents/caigouhetong.vue";
import modalAmendVue from "./modalAmend.vue";

export default {
  extends: baseList,
  components: {
    Caigouhetong,
    modalAmendVue,
  },
  data() {
    return {
      table: {
        mname: "customer",
        key: "id",
        url: {
          list: "/admin/system/procurementContract/list",
          del: "/admin/system/procurementContract",
        },
        output: false,
        order: "id",
        qrCode: "qrCode",
      },
      actions: [],
      filters: [
        {
          label: "合同名称",
          KeyEnter: this.search,
          name: "contractName",
          value: "",
          type: "input",
        },
        {
          label: "付款方式",
          name: "payMethod",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            { value: 1, name: "对公协议发货" },
            { value: 2, name: "对公预付款" },
            { value: 3, name: "对私预付款" },
          ],
        },
        {
          label: "供应商",
          KeyEnter: this.search,
          name: "supplierName",
          value: "",
          type: "input",
        },
        {
          label: "订单编号",
          KeyEnter: this.search,
          name: "procurementNum",
          value: "",
          type: "input",
        },
        {
          label: "付款状态",
          name: "payState",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            { value: 1, name: "已付款" },
            { value: 2, name: "未付款" },
          ],
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "合同名称",
          key: "contractName",
          minWidth: 260,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.contractName;
            return (
              <span
                style={{ "font-size": "14px", cursor: "pointer", color: "#2d8cf0" }}
                onClick={() => this.toInfo(row)}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "物资信息",
          minWidth: 250,
          key: "consumableIdsList",
          render: (h, params) => {
            return (
              <div>
                {params.row.consumableIdsList.map((item) => {
                  const budget = item.jdPrice;
                  const num = new Intl.NumberFormat("zh-CN", {
                    style: "currency",
                    currency: "CNY",
                  }).format(budget);
                  return (
                    <div>
                      {item.brand ? item.brand + "/" : ""}
                      {item.model}/{item.name}*{item.alertNum}
                      {item.unit}-<span style="color:blue">单价: {num}</span>元
                    </div>
                  );
                })}
              </div>
            );
          },
        },
        {
          title: "供应商",
          key: "supplierName",
          minWidth: 260,
          align: "left",
        },
        {
          title: "合同",
          minWidth: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            if (row.fileUrl !== null) {
              return (
                <svg
                  onClick={() => {
                    this.handleRender(row.fileUrl);
                  }}
                  t="1686795127586"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7800"
                  width="20"
                  height="20"
                >
                  <path
                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                    fill="#CCA352"
                    p-id="7801"
                  ></path>
                  <path
                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                    fill="#FFFFFF"
                    p-id="7802"
                  ></path>
                  <path
                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                    fill="#FFCC66"
                    p-id="7803"
                  ></path>
                </svg>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "金额",
          key: "contractMoney",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const budget = row.contractMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        {
          title: "付款方式",
          minWidth: 150,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.payMethod === 1
                ? "对公协议发货"
                : row.payMethod === 2
                ? "对公预付款"
                : row.payMethod === 3
                ? "对私预付款"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "付款状态",
          key: "name",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.payState;
            return (
              <modalAmendVue
                text={text}
                item={row}
                priceType="payState"
                onReset={() => {
                  this.search();
                }}
              />
            );
          },
        },
        {
          title: "付款比例",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return <span style={{ "font-size": "14px" }}>{row.payProportion}%</span>;
          },
        },
        {
          title: "开票状态",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.invoiceState === 1 ? "已开票" : row.invoiceState === 2 ? "未开票" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.tobianji(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  编辑
                </Button>
              );
            },
            "delete",
          ],
        },
      ],
    };
  },
  created() {
    let query = this.$route.query;
    if (query.procurementNum) {
      this.query.procurementNum = query.procurementNum;
    }
  },
  methods: {
    toInfo(row) {
      $utils.url.push({
        name: "ProcureInfo",
        query: { kv: row.procurementId },
      });
    },
    handleRender(text) {
      const texturl = text.split(",");
      for (let i = 0; i < texturl.length; i++) {
        texturl[i] = config.IMAGE_HOST + texturl[i];
      }
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `查看附件`,
        width: "400px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <List border size="small">
                {files.map((item) => {
                  return (
                    <ListItem>
                      <a href={item.url} target="_blank">
                        {item.name}
                      </a>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          );
        },
      });
    },
    tobianji(row) {
      this.$Modal.success({
        closable: true,
        title: "编辑采购合同",
        width: "800px",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <Caigouhetong
                onOnCancel={() => {
                  this.onClose();
                }}
                item={row.id}
                procurementId={row.procurementId}
                action="edit"
              />
            </div>
          );
        },
      });
    },
  },
};
</script>
<style scoped></style>
